import { render } from "./clientetipo.vue?vue&type=template&id=ee1c8e36&scoped=true"
import script from "./clientetipo.vue?vue&type=script&lang=js"
export * from "./clientetipo.vue?vue&type=script&lang=js"

import "./clientetipo.vue?vue&type=style&index=0&id=ee1c8e36&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee1c8e36"]])

export default __exports__